import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  children,
  className = '',
  href,
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 font-semibold rounded-lg transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-remax-red text-white hover:bg-red-700 focus:ring-remax-red',
    secondary: 'bg-remax-blue text-white hover:bg-blue-800 focus:ring-remax-blue',
    outline: 'bg-white text-remax-blue border-2 border-remax-blue hover:bg-blue-50 focus:ring-remax-blue'
  };
  const buttonContent = <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-8">
      {children}
    </motion.button>;
  if (href) {
    return <a href={href} className="inline-block" data-id="element-9">
        {buttonContent}
      </a>;
  }
  return buttonContent;
};